/* =================================================================================================
 * Page « Nouvelle collection » — bandeau animé.
 *
 * Le seul rôle du script est de déclencher l'animation quand le bandeau entre
 * dans l'écran : tout le mouvement est décrit en CSS. Sans ce déclenchement,
 * l'animation se jouerait au chargement de la page et serait terminée avant
 * que le visiteur n'arrive dessus.
 * ===============================================================================================*/

(function () {
  'use strict';

  if (customElements.get('campus-hero')) return;

  class CampusHero extends HTMLElement {
    connectedCallback() {
      // Sans IntersectionObserver, on affiche simplement le résultat final.
      if (!window.IntersectionObserver) {
        this.classList.add('is-visible');
        return;
      }

      var seuil = parseFloat(this.dataset.threshold);
      if (isNaN(seuil)) seuil = 0.35;
      var rejouer = this.dataset.replay !== 'false';

      // Deux seuils volontairement distincts : l'animation se déclenche quand
      // une bonne part du bandeau est visible, mais elle ne se réarme que
      // lorsqu'il a complètement quitté l'écran. Réarmer au même seuil ferait
      // rebondir les coques vers le centre sous les yeux du visiteur.
      this.observer = new IntersectionObserver((entrees) => {
        var e = entrees[0];
        if (e.intersectionRatio >= seuil) {
          this.classList.add('is-visible');
          if (!rejouer) {
            this.observer.disconnect();
            this.observer = null;
          }
        } else if (rejouer && !e.isIntersecting) {
          this.classList.remove('is-visible');
        }
      }, { threshold: [0, seuil] });

      this.observer.observe(this);

      // Dans l'éditeur de thème, l'aperçu peut être hors écran au moment du
      // rendu : on montre le résultat final pour que la section reste visible.
      if (window.Shopify && window.Shopify.designMode) {
        window.setTimeout(() => this.classList.add('is-visible'), 400);
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  customElements.define('campus-hero', CampusHero);
})();
